import { RootState } from '@/modules/ewwms/store';

import { GetterTree } from 'vuex';
import { State } from './state';
import { Artikel } from '@/modules/ewwms/models/Lager/ArtikelModels';

export type Getters = {
  artikel(state: State): Array<Artikel>;
};

export const getters: GetterTree<State, RootState> & Getters = {
  artikel(state) {
    return state.artikel;
  },
};
